<template>
<div class="chapter">
<div class="inner_page">
<h1>Miss Ella of Commander’s Palace</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<a href="#/ch01">Acknowledgments </a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch02">Foreword </a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch03">Introduction </a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch04"><span class="numeral">1 </span>Scrambled Eggs, Sautéed Bananas and One Unshakeable Family
              (1925–1943) </a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch05"><span class="numeral">2 </span>“Your Restaurant Stinks!” (1944–1954) </a>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch06" title="Link target outside of Sample"><span class="numeral">3 </span>“Some Girls Went to Finishing School. I Went to Café Lafitte.” </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch07" title="Link target outside of Sample"><span class="numeral">4 </span>A Vision on Royal Street (1955–1969) </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch08" title="Link target outside of Sample"><span class="numeral">5 </span>There’s Just No Stopping Mardi Gras Memories </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch09" title="Link target outside of Sample"><span class="numeral">6 </span>Divisions (1970–1973) </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch10" title="Link target outside of Sample"><span class="numeral">7 </span>Big Sister, Larger than Life </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch11" title="Link target outside of Sample"><span class="numeral">8 </span>Creole-ize It: Pioneering Modern American Cuisine (1974–1983) </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch12" title="Link target outside of Sample"><span class="numeral">9 </span>Are You Sure You Want to Run a Restaurant? </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch13" title="Link target outside of Sample"><span class="numeral">10 </span>Lighting a Fire: Emeril Lagasse, Jamie Shannon and the Commander’s
              Palace Classroom (1983–2001) </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch14" title="Link target outside of Sample"><span class="numeral">11 </span>Two Passions, Many Loves </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch15" title="Link target outside of Sample"><span class="numeral">12 </span>Passages (1985–2005 . . . and beyond) </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch16" title="Link target outside of Sample"><span class="numeral">13 </span>“Lucky, Lucky Me” </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch17" title="Link target outside of Sample">Afterword: Saloon in the Sky </span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01-toc.vue?434b1310